export const LogEvent = {
    /**
     * register log
     */
    REGISTER_LOG: "public.holacarrentals.log.register"
};
